import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/MANTENIMIENTOARRANQUE/ARRANQUE_01.png";
import Img_Two from "./../../../../sources/imgs/MANTENIMIENTOARRANQUE/ARRANQUE_02.png";
import Img_Three from "./../../../../sources/imgs/MANTENIMIENTOARRANQUE/ARRANQUE_03.png";
import Img_Four from "./../../../../sources/imgs/MANTENIMIENTOARRANQUE/ARRANQUE_04.png";
import Img_Five from "./../../../../sources/imgs/MANTENIMIENTOARRANQUE/ARRANQUE_05.png";
import Img_Six from "./../../../../sources/imgs/MANTENIMIENTOARRANQUE/ARRANQUE_06.png";
import Img_Seven from "./../../../../sources/imgs/NMAP/NMAP_07.png";
import Img_Eight from "./../../../../sources/imgs/NMAP/NMAP_08.png";
import Img_Nine from "./../../../../sources/imgs/NMAP/NMAP_09.png";
import Img_Ten from "./../../../../sources/imgs/NMAP/NMAP_10.png";
import Img_Eleven from "../../../../sources/imgs/NMAP/NMAP_11.png";
import Img_Twelve from "../../../../sources/imgs/NMAP/NMAP_12.png";
import Img_Thirteen from "../../../../sources/imgs/NMAP/NMAP_13.png";
import Img_Fourteen from "../../../../sources/imgs/NMAP/NMAP_14.png";
import Img_Fifteen from "../../../../sources/imgs/NMAP/NMAP_15.png";
import Img_Sixteen from "../../../../sources/imgs/NMAP/NMAP_16.png";
import Img_Seventeen from "../../../../sources/imgs/NMAP/NMAP_17.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function PRIVILEGIO_01 (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> MANTENIMIENTO DE ACCESO POR ARCHIVO EN RUTA DE ARRANQUE.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a Mantenimiento de Acceso por archivo en directorio de ruta de arranque.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Una de las <span className="span-pink">técnicas</span> más <span className="span-white">sencillas</span> y <span className="span-white">efectivas</span> para lograr <span className="span-pink">persistencia</span> en <span className="span-blue">sistemas Windows</span> consiste en aprovechar la <span className="span-white">carpeta de inicio (Startup Folder)</span>. Esta carpeta contiene <span className="span-blue">accesos directos</span> o <span className="span-blue">scripts</span> que <span className="span-white">Windows</span> <span className="span-pink">ejecuta automáticamente</span> cuando el usuario <span className="span-white">inicia sesión</span>. Copiar un archivo <i className="span-white">.bat</i>, <i className="span-white">.ps1</i>, o un <span className="span-blue">acceso directo</span> que invoque un <span className="span-white">script malicioso</span> en esta <span className="span-pink">ubicación</span> permite que dicho <span className="span-white">archivo</span> se <span className="span-pink">ejecute</span> cada vez que se <span className="span-pink">inicie sesión</span> en el sistema.
            </p>

            <p>
                Este <span className="span-pink">método</span> <span className="span-white">no requiere privilegios de administrador</span> si se usa la <i className="span-white">carpeta de inicio del usuario</i> actual, y es ampliamente utilizado tanto en <span className="span-blue">pruebas de intrusión</span> como en <span className="span-blue">entornos de laboratorio</span> de <span className="span-yellow">hacking ético</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Ruta de Directorio arranque.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                En <span className="span-blue">Windows</span>, la <span className="span-white">ruta del directorio de arranque</span> es: 
            </p>

            <p>
                <i className="span-white">
                    C:\Users\&lt;usuario&gt;\AppData\Roaming\Microsoft\Windows\Start Menu\Programs\Startup
                </i>
            </p>

            <p>
                Podemos <span className="span-pink">acceder</span> a el utilizando el <span className="span-white">comando siguiente</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`cd "$env:APPDATA\\Microsoft\\Windows\\Start Menu\\Programs\\Startup"`}
            />

            <p>
                <span className="span-yellow">Nota:</span> Este <span className="span-pink">comando</span> obtiene la <span className="span-pink">ruta dinámicamente</span> usando <i className="span-white">$env:APPDATA</i> en <span className="span-blue">PowerShell</span>.
            </p>

            <p><span className="span-white">Realizando:</span></p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. VISUALIZACIÓN DE DIRECTORIO DE RUTA DE ARRANQUE."}
                title = {"Descripción de imagen."}
                text = {"1. Visualización de directorio de ruta de arranque."}
            />
            
            <p>
                Veamos los <span className="span-pink">pasos a seguir</span>, dependiendo de un tipo de <span className="span-white">archivo</span> a <span className="span-pink">configurar</span>.
            </p>

            <b>
                <p className="span-blue">
                    1. Mantenimiento de Acceso por archivo <i className="span-blue">.bat</i>, <i className="span-blue">.ps1</i>, <i className="span-blue">.py</i>, <i className="span-blue">.pyw</i>, etc.
                </p>
            </b>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`Copy-Item -Path "C:\\<ruta-y-archivo-revershell>.bat" -Destination "$env:APPDATA\\Microsoft\\Windows\\Start Menu\\Programs\\Startup"`}
            />

            <p>
                Este <span className="span-pink">comando</span> copia el <span className="span-white">archivo directamente</span> en la <span className="span-white">carpeta de inicio</span>. Se <span className="span-pink">ejecutará</span> cada vez que el usuario <span className="span-blue">inicie sesión</span>.
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. COPIADO DE ARCHIVO .BAT EN DIRECTORIO EN RUTA DE ARRANQUE."}
                title = {"Descripción de imagen."}
                text = {"2. Copiado de archivo .bat en directorio en ruta de arranque."}
            />

            <p>
                Si nos hemos <span className="span-pink">conectado</span> por algun otro <span className="span-white">archivo</span>  o método de <span className="span-yellow">Reverse Shell</span> el cual <span className="span-pink">NO</span> sea el que deseemos colocar en el <span className="span-white">directorio de ruta de arranque</span>, debemos <span className="span-pink">crear</span> el <span className="span-white">archivo</span> antes de <span className="span-pink">copiarlo</span>.
            </p>

            <p>
                Para ello, podemos <span className="span-pink">utilizar</span> el <span className="span-white">comando</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`@"
<codigo-de-revershell>
"@ > "$env:APPDATA\\Microsoft\\Windows\\Start Menu\\Programs\\Startup\\<nombre-reverseshell>.bat"`}
            />

            <p>
                <span className="span-white">Realizando:</span>
            </p>


            <Img
                img = {Img_Three}
                alt = {"Imagen 3. CREACIÓN DE ARCHIVO .BAT EN DIRECTORIO EN RUTA DE ARRANQUE."}
                title = {"Descripción de imagen."}
                text = {"3. Creación de archivo .bat en directorio en ruta de arranque."}
            />

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. VISUALIZACIÓN DE ARCHIVO .BAT CREADO EN DIRECTORIO DE RUTA DE ARRANQUE."}
                title = {"Descripción de imagen."}
                text = {"4. Visualización de archivo .bat creado en directorio de ruta de arranque."}
            />

            <p>
                <span className="span-yellow">Nota:</span> Al realizar este <span className="span-pink">método</span>, la <span className="span-pink">Reverse Shell</span> se <span className="span-pink">ejecuta</span> de <span className="span-white">forma directa</span> desde el <span className="span-pink">archivo</span> colocado.
            </p>

            <b>
                <p className="span-blue">
                    2. Mantenimiento de Acceso por acceso directo de archivo <i className="span-blue">.bat</i>, <i className="span-blue">.ps1</i>, <i className="span-blue">.py</i>, <i className="span-blue">.pyw</i>, etc.
                </p>
            </b>

            <p>
                Tambien podemos <span className="span-white">utilizar</span> la <span className="span-pink">creación</span> de un <span className="span-blue">acceso directo</span>, que permite <span className="span-pink">ocultar la ejecución</span> detrás de <i className="span-white">powershell.exe</i>, lo que ayuda a <span className="span-white">reducir sospechas</span>.
            </p>

            <p>
                Para ello, <span className="span-pink">utilizamos</span> los <span className="span-white">comandos siguientes</span>, <span className="span-white">paso</span> a <span className="span-white">paso</span>:
            </p>

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`# Carpeta Startup del usuario actual
$startupDir = [Environment]::GetFolderPath("Startup")`}
            />

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`$shortcut = Join-Path $startupDir "ReverseShell.lnk"`}
            />

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`# Ruta a tu script .pyw
$script = "<ruta-y-archivo>.pyw"`}
            />

            <Comand
                funcionNotificacion={props.funcionNotificacion}
                notifications={props.notifications}
                code={`# Crear acceso directo que se abre con su aplicación predeterminada (pythonw.exe, python.exe o cmd.exe)
$WshShell    = New-Object -ComObject WScript.Shell
$shortcutObj = $WshShell.CreateShortcut($shortcut)
$shortcutObj.TargetPath = $script
$shortcutObj.WorkingDirectory = Split-Path $script
$shortcutObj.Save()`}
            />

            <p>Veamos un <span className="span-white">ejemplo:</span></p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. CREACIÓN DE ARCHIVO .LNK PARA DIRECTORIO EN RUTA DE ARRANQUE."}
                title = {"Descripción de imagen."}
                text = {"5. Creación de archivo .lnk para directorio en ruta de arranque."}
            />

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. CREACIÓN DE ARCHIVO .LNK PARA DIRECTORIO EN RUTA DE ARRANQUE."}
                title = {"Descripción de imagen."}
                text = {"6. Creación de archivo .lnk para directorio en ruta de arranque."}
            />

            <p>
                Para que un <i className="span-white">.py</i> o un <i className="span-white">.pyw</i> pueda <span className="span-pink">ejecutarse</span>, Verifica de que <i className="span-white">pythonw.exe</i> se encuentre en el <span className="span-blue">PATH</span> del <span className="span-pink">sistema victima</span> o especifica su <span className="span-pink">ruta completa</span>.
            </p>

            <p>
                <span className="span-yellow">Nota:</span> Realizar este <span className="span-pink">método</span> crea un <span className="span-blue">acceso directo</span> <i className="span-white">.lnk</i> en la <span className="span-white">carpeta de inicio</span>, ejecutando <i className="span-white">powershell.exe</i> con <span className="span-blue">argumentos</span> para correr el <span className="span-blue">archivo</span> en <span className="span-white">modo oculto</span> y <span className="span-white">sin restricciones</span>.
            </p>
        </>
    );
}